(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('ReportInfoModalCtrl', ['$scope', 'Card', '$rootScope', 'CardRegistry', '$uibModalInstance', function ($scope, Card, $rootScope, CardRegistry, $uibModalInstance) {
    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);
})();
